import { useState } from 'react';
import { toLocalISODate } from '../../utils/dateUtils';

const weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

function RangeCalendar({ start, end, onSelect }) {
  const initial = start ? new Date(start) : new Date();
  const [viewYear, setViewYear] = useState(initial.getFullYear());
  const [viewMonth, setViewMonth] = useState(initial.getMonth());
  const [hoverDate, setHoverDate] = useState(null);

  const firstOfMonth = new Date(viewYear, viewMonth, 1);
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
  const startOffset = firstOfMonth.getDay();
  const monthLabel = firstOfMonth.toLocaleString('en', { month: 'long', year: 'numeric' });

  const goPrevMonth = () => {
    if (viewMonth === 0) {
      setViewMonth(11);
      setViewYear((year) => year - 1);
    } else {
      setViewMonth((month) => month - 1);
    }
  };

  const goNextMonth = () => {
    if (viewMonth === 11) {
      setViewMonth(0);
      setViewYear((year) => year + 1);
    } else {
      setViewMonth((month) => month + 1);
    }
  };

  const handleDayClick = (iso) => {
    if (!start || end) {
      onSelect(iso, null);
    } else if (iso < start) {
      onSelect(iso, start);
    } else {
      onSelect(start, iso);
    }
  };

  const previewEnd = start && !end && hoverDate ? hoverDate : null;
  const effectiveEnd = end || previewEnd;
  let lo = null;
  let hi = null;
  if (start && effectiveEnd) {
    lo = start < effectiveEnd ? start : effectiveEnd;
    hi = start < effectiveEnd ? effectiveEnd : start;
  } else if (start) {
    lo = start;
    hi = start;
  }

  const cells = [];
  for (let i = 0; i < startOffset; i += 1) cells.push(null);
  for (let day = 1; day <= daysInMonth; day += 1) cells.push(day);

  return (
    <div className="range-cal">
      <div className="range-cal-header">
        <button type="button" className="range-cal-nav" onClick={goPrevMonth} aria-label="Previous month">‹</button>
        <span>{monthLabel}</span>
        <button type="button" className="range-cal-nav" onClick={goNextMonth} aria-label="Next month">›</button>
      </div>
      <div className="range-cal-weekdays">
        {weekdays.map((day) => <span key={day}>{day}</span>)}
      </div>
      <div className="range-cal-grid" onMouseLeave={() => setHoverDate(null)}>
        {cells.map((day, index) => {
          if (day === null) return <div key={`empty-${index}`} className="range-cal-cell empty" />;
          const date = new Date(viewYear, viewMonth, day);
          const iso = toLocalISODate(date);
          const isEndpoint = iso === lo || iso === hi;
          const inRange = lo && hi && iso > lo && iso < hi;
          let cellClass = 'range-cal-cell';
          if (isEndpoint) cellClass += ' endpoint';
          if (inRange) cellClass += ' in-range';
          if (isEndpoint && iso === lo) cellClass += ' range-lo';
          if (isEndpoint && iso === hi) cellClass += ' range-hi';
          return (
            <div key={iso} className={cellClass}>
              <button
                type="button"
                className={`range-cal-day${isEndpoint ? ' is-endpoint' : ''}`}
                onClick={() => handleDayClick(iso)}
                onMouseEnter={() => setHoverDate(iso)}
              >
                {day}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RangeCalendar;
